export default __webpack_public_path__ + "static/media/thumbnail.2f565b55.png";